import React, { useState, useEffect } from 'react';
import { api_url } from "../globalFunction/global_string";
import DataTable from 'react-data-table-component';
import { SiteTitle } from "../SiteTitle";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label, Input } from 'reactstrap';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import '../FetchTrackingDetail.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { useLocation } from 'react-router-dom';
import { data } from 'jquery';

const MySwal = withReactContent(Swal);


function FetchTenTrackingDetail() {
    const [trackingData, setTrackingData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [modal, setModal] = useState(false); // 定義模態對話框狀態
    const [editData, setEditData] = useState({});  // 編輯按鈕使用
    const [selectedId, setSelectedId] = useState(null);  //保存的時候帶ID
    const [selectedFiles, setSelectedFiles] = useState([]); //選擇檔案放置位置
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const location = useLocation();
    const { build_date, projectName } = location.state || {};
    const [reportCollapseStatus, setReportCollapseStatus] = useState({}); //追蹤報告標題收合使用


    // 追蹤報告標題切換收合/展開狀態的函數
    const toggleReportCollapse = scanId => {
        setReportCollapseStatus(prevStatus => ({
            ...prevStatus,
            [scanId]: !prevStatus[scanId]
        }));
    };

    //利用scan_id來做分組函數       
    const groupByproblemID = (data) => {
        return data.reduce((groups, item) => {
            if (!groups[item.trbg0101Id]) {
                groups[item.trbg0101Id] = [];
            }
            groups[item.trbg0101Id].push(item);
            return groups;
        }, {});
    };
    const loadData = async () => {
        setIsLoading(true);
        let apiUrl = `${api_url}/api/TrackBackground/GetTenUNitOneTrackBackgroundDetail`;
        const formData = new FormData();
        formData.append("usertype", localStorage.getItem('login_user_type'));
        formData.append("build_date", build_date);
        formData.append("projectName", projectName);
        formData.append("projectnet", localStorage.getItem('login_user_net_id'));
        formData.append("projectunit", localStorage.getItem('login_user_unit_id'));
        try {
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Authorization": localStorage.getItem('accessToken') },
                body: formData
            });
            const data = await response.json();
            if (response.ok && data.statusCode === 200) {
                const groupedData = groupByproblemID(data.row);
                setTrackingData(groupedData);
            } else {
                throw new Error('無效的回應格式');
            }
        } catch (error) {
            setError(error.message);
        } finally {
            setIsLoading(false);
        }
    };


    useEffect(() => {
        if (build_date, projectName) {
            loadData();
        }
    }, [build_date, projectName]);




    if (isLoading) {
        return <div>正在加載...</div>;
    }

    if (error) {
        return <div>發生錯誤: {error}</div>;
    }
    function combinePdfData(trackingData) {
        const groupedData = {};

        trackingData.forEach(item => {
            const key = `${item.projectId}_${item.problemType}`;

            if (!groupedData[key]) {
                groupedData[key] = { ...item, problemSupportingInformation: [], noteFiles: [] };
            }

            if (item.problemSupportingInformation && item.problemSupportingInformation.trim() !== '') {
                groupedData[key].problemSupportingInformation.push({
                    fileName: item.problemSupportingInformation.split('\\').pop(),
                    filepath: item.problemSupportingInformation,
                    fileId: item.problemFileId
                });
            }
            if (item.noteFile && item.noteFile.trim() !== '') {
                groupedData[key].noteFiles.push({
                    fileName: item.noteFile.split('\\').pop(),
                    filepath: item.noteFile,
                    fileId: item.problemFileId
                });
            }
        });

        return Object.values(groupedData).map(item => {
            return {
                ...item,
                problemSupportingInformation: item.problemSupportingInformation.map(file => file.fileName).join(', '),
                problemSupportingInformations: item.problemSupportingInformation,
                noteFile: item.noteFiles.map(file => file.fileName).join(', '),
                noteFiles: item.noteFiles
            };
        });
    }



    //佐證資料傳檔案使用
    const handleFileChange = (event) => {
        const files = Array.from(event.target.files);
        const maxFileSize = 10 * 1024 * 1024; // 10MB
        const maxFiles = 10;

        const validFiles = files.filter(file => file.size <= maxFileSize);
        if (validFiles.length > maxFiles) {
            MySwal.fire({
                title: '錯誤',
                text: `最多只能上傳 ${maxFiles} 個文件`,
                icon: 'error',
                confirmButtonText: '確定',
                customClass: {
                    confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
            });
            return;
        }
        if (validFiles.length !== files.length) {
            MySwal.fire({
                title: '警告',
                text: '某些文件超過了大小限制（10MB）',
                icon: 'warning',
                confirmButtonText: '確定',
                customClass: {
                    confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
            });
        }


        // 更新狀態以保存選定的文件
        setSelectedFiles(validFiles);

        setEditData({
            ...editData,
            ProblemSupportingInformation: validFiles,
        });
    };
    //刪除檔案
    const handleRemoveFile = async (fileId, index) => {
        // 移除本地狀態中的檔案
        setUploadedFiles(currentFiles => {
            const updatedFiles = [...currentFiles];
            updatedFiles.splice(index, 1);
            return updatedFiles;
        });

        // 準備發送到後端的請求
        let formData = new FormData();
        formData.append('id', fileId);
        const apiUrl = `${api_url}/api/TrackBackground/DelProblemFile`;

        try {
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Authorization": localStorage.getItem('accessToken') },
                body: formData
            });
            if (!response.ok) {
                throw new Error('刪除文件時發生錯誤');
            }

            // 處理成功的響應
            const data = await response.json();
            if (data.statusCode === 200) {
                Swal.fire({
                    title: '成功!',
                    text: '此檔案已刪除成功',
                    icon: 'success',
                    confirmButtonText: '好的'
                })
            }
        } catch (error) {
            console.error('刪除文件時發生錯誤', error);
        }
    };


    // 修改按鈕事件處理
    const handleEdit = (data) => {
        const updatedData = {
            ...data,
            problemProcessingMethod: data.problemProcessingMethod ?? '4'
        };

        setEditData(updatedData);
        setSelectedId(data.id);
        setSelectedFiles([]);

        if (data.problemSupportingInformations && Array.isArray(data.problemSupportingInformations)) {
            // 直接處理物件陣列
            const pdfFiles = data.problemSupportingInformations.map((fileInfo) => {
                return {
                    id: fileInfo.fileId, // 從物件中直接取得 fileId
                    name: fileInfo.fileName, // 直接使用處理過的 fileName
                    path: fileInfo.fileName // 如果需要原始路徑，這裡可能需要調整
                };
            });
            setUploadedFiles(pdfFiles);
        } else {
            setUploadedFiles([]);
        }

        toggleModal();
    };



    // 更新數據的函數
    const handleUpdateForN = async () => {
        let formData = new FormData();
        Object.keys(editData).forEach(key => {
            formData.append(key, editData[key]);
        });
        if (selectedFiles) {
            selectedFiles.forEach(file => {
                formData.append("Files", file);
            });
        }
        let apiUrl = `${api_url}/api/TrackBackground/PutTenUNitOneReportDetail`;

        try {
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Authorization": localStorage.getItem('accessToken') },
                body: formData
            });
            const data = await response.json();
            console.log(data.statusCode)
            if (data.statusCode === 200) {
                loadData();
                toggleModal();
            } else {
                Swal.fire({
                    title: '錯誤',
                    text: data.detail,
                    icon: 'error',
                    confirmButtonText: '好的'
                });
            }
        } catch (error) {
            setError(error.message);
        } finally {
            setIsLoading(false);
        }
    };
    const handleUpdateForM = async () => {
        let formData = new FormData();
        Object.keys(editData).forEach(key => {
            formData.append(key, editData[key]);
            formData.append("problemPreliminaryOpinion", editData.problemPreliminaryOpinion || "");
            formData.append("problemPreliminaryResults", editData.problemPreliminaryResults || null);
        });

        let apiUrl = `${api_url}/api/TrackBackground/PutTenUNitOneReportDetailForM`;

        try {
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Authorization": localStorage.getItem('accessToken') },
                body: formData
            });
            const data = await response.json();
            if (data.statusCode === 200) {
                loadData();
                toggleModal();
            } else {
                Swal.fire({
                    title: '錯誤',
                    text: data.detail,
                    icon: 'error',
                    confirmButtonText: '好的'
                });
            }
        } catch (error) {
            setError(error.message);
        } finally {
            setIsLoading(false);
        }
    };
    // 切換模態對話框的顯示狀態
    const toggleModal = () => {
        setModal(!modal);
    };
    //單位提交按鈕
    const handleSubmitForN = async (groupData) => {

        const ids = groupData.map(item => item.id);
        const t1Id = groupData.map(item => item.trbg0101Id);

        let confirmSubmit = false;

        confirmSubmit = await Swal.fire({
            title: '確定提交報告?',
            text: '提交後內容將無法更改',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: '確定',
            cancelButtonText: '取消'
        }).then(result => {
            return result.isConfirmed
        });

        if (!confirmSubmit) {
            return;
        }
        const formData = new FormData();
        ids.forEach(id => formData.append('ids', id));
        t1Id.forEach(id => formData.append('t1Id', id));
        formData.append('local_unit_id', localStorage.getItem('login_user_unit_id'));
        formData.append('local_net_id', localStorage.getItem('login_user_net_id'));
        formData.append('user_type', userType);
        formData.append('username', localStorage.getItem('login_user_name'));
        let apiUrl = `${api_url}/api/TrackBackground/TenUNitTrackFunticon`;

        try {
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Authorization": localStorage.getItem('accessToken') },
                body: formData
            });
            if (response.ok) {
                loadData();
                Swal.fire({
                    icon: 'success',
                    title: '【提交成功】',
                    text: '恭喜'
                });
            } else {
                console.error("提交失败", response);
            }
        } catch (error) {
            console.error("提交時出現錯誤", error);
        }
    }
    //區網提交按鈕
    const handleSubmitForM = async (groupData, scanId) => {
        const ids = groupData.map(item => item.trbg0101Id);
        let confirmSubmit = false;
        console.log(groupData)
        confirmSubmit = await Swal.fire({
            title: '確定提交報告?',
            text: '提交後內容將無法更改',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: '確定',
            cancelButtonText: '取消'
        }).then(result => {
            return result.isConfirmed
        });

        if (!confirmSubmit) {
            return;
        }
        const formData = new FormData();
        ids.forEach(id => formData.append('ids', id));
        formData.append('scan_id', groupData[0].scan_id);
        formData.append('ProjectId', groupData[0].trbg0101Id);
        formData.append('build_date', groupData[0].build_date);
        if (userType === 'M') {
            formData.append('IsNetTrack', 'true');
            formData.append('IsadminTrack', 'false');
            formData.append('IsUnitTrack', 'false');
        } else if (userType === 'N') {
            formData.append('IsUnitTrack', 'true');
            formData.append('IsadminTrack', 'false');
            formData.append('IsNetTrack', 'false');
        } else {
            formData.append('IsadminTrack', 'false');
            formData.append('IsNetTrack', 'false');
            formData.append('IsUnitTrack', 'false');
        }

        formData.append('usertype', userType);
        formData.append('username', localStorage.getItem('login_user_name'));
        formData.append('judge', '1');

        let apiUrl = `${api_url}/api/TrackBackground/PutTenOneTrackBackgroundReportlist`;

        try {
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Authorization": localStorage.getItem('accessToken') },
                body: formData
            });
            console.log(response)
            if (response.ok) {
                loadData();
                Swal.fire({
                    icon: 'success',
                    title: '【提交成功】',
                    text: '恭喜'
                });
            } else {
                console.error("提交失败", response);
            }
        } catch (error) {
            console.error("提交時出現錯誤", error);
        }
    }

    //下載
    const handleDownload = async (filePath) => {
        const segments = filePath.split('\\');
        const fileNameWithExtension = segments.pop();
        const encodedFileName = encodeURIComponent(fileNameWithExtension);
        const encodedPath = segments.join('/');
        const fileUrl = `${api_url}/${encodedPath}/${encodedFileName}`;
        console.log(fileUrl);

        try {
            const response = await fetch(fileUrl);
            if (!response.ok) {
                throw new Error(`Server responded with ${response.status}: ${response.statusText}`);
            }
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', decodeURIComponent(encodedFileName));
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Failed to fetch file:', error);
        }
    };


    const userType = localStorage.getItem('login_user_type');


    let columns = [
        {
            name: '問題類型',
            selector: row => row.problemType,
            sortable: true,
            cell: row => <div className="wrap-text">{row.problemType}</div>
        },
        {
            name: '風險程度',
            selector: row => row.problemRiskLevel,
            sortable: true,
            cell: row => {
                const riskLevelMapping = {
                    '5': '重',
                    '4': '高',
                    '3': '中',
                    '2': '低',
                    '1': '訊息',
                    '0': '-'
                };
                return <div className="wrap-text">{riskLevelMapping[row.problemRiskLevel]}</div>;
            }
        },
        {
            name: '問題數量',
            selector: row => row.problemNumber,
            sortable: true,
            cell: row => <div className="wrap-text">{row.problemNumber}</div>
        },
        {
            name: '處理方式',
            selector: row => row.problemProcessingMethod,
            sortable: false,
            cell: row => {
                const ProcessingMethodMapping = {
                    '4': '已修補',
                    '3': '未修補',
                    '2': '誤判',
                    '1': '其他'
                };
                return <div className="wrap-text">{ProcessingMethodMapping[row.problemProcessingMethod]}</div>;
            }
        },
        {
            name: '改善回應',
            selector: row => row.problemimProvementResponse,
            sortable: false,
            cell: row => <div className="wrap-text">{row.problemimProvementResponse}</div>
        },
        {
            name: '佐證資料',
            selector: row => row.problemSupportingInformation,
            sortable: false,
            cell: row => {
                if (row.problemSupportingInformations && Array.isArray(row.problemSupportingInformations)) {
                    return (
                        <div className="wrap-text">
                            {row.problemSupportingInformations.map((fileInfo, index) => {
                                const { fileName, filepath } = fileInfo;
                                const fileExtension = fileName.toLowerCase().match(/\.(pdf|html?)$/i);
                                let iconSrc = "/PDF.png";
                                if (fileExtension) {

                                    switch (fileExtension[1]) {
                                        case "pdf":
                                            iconSrc = "/PDF.png";
                                            break;
                                        case "html":
                                            iconSrc = "/html.png";
                                        default:
                                            break;
                                    }
                                }
                                return (
                                    <div key={index} style={{ display: 'flex', alignItems: 'center' }}>
                                        <img src={iconSrc} alt={fileExtension ? fileExtension[1].toUpperCase() : "File"} style={{ width: '20px', height: '20px', cursor: 'pointer', marginRight: '5px' }} />
                                        <span style={{ cursor: 'pointer' }} onClick={() => handleDownload(filepath)}>{fileName}</span>
                                    </div>
                                );
                            })}
                        </div>
                    );
                } else {
                    return <div></div>; // 如果沒有資料，顯示空白
                }
            }
        },
        {
            name: '備註',
            selector: row => row.note,
            sortable: false,
            cell: row => <div className="wrap-text">{row.note}</div>
        },
        {
            name: '備註檔案',
            selector: row => row.noteFile,
            sortable: false,
            cell: row => {
                if (row.noteFiles && Array.isArray(row.noteFiles)) {
                    return (
                        <div className="wrap-text">
                            {row.noteFiles.map((fileInfo, index) => {
                                const { fileName, filepath } = fileInfo;
                                const fileExtension = fileName.toLowerCase().match(/\.(pdf|html?)$/i);
                                let iconSrc = "/PDF.png";
                                if (fileExtension) {

                                    switch (fileExtension[1]) {
                                        case "pdf":
                                            iconSrc = "/PDF.png";
                                            break;
                                        case "html":
                                            iconSrc = "/html.png";
                                        default:
                                            break;
                                    }
                                }
                                return (
                                    <div key={index} style={{ display: 'flex', alignItems: 'center' }}>
                                        <img src={iconSrc} alt={fileExtension ? fileExtension[1].toUpperCase() : "File"} style={{ width: '20px', height: '20px', cursor: 'pointer', marginRight: '5px' }} />
                                        <span style={{ cursor: 'pointer' }} onClick={() => handleDownload(filepath)}>{fileName}</span>
                                    </div>
                                );
                            })}
                        </div>
                    );
                } else {
                    return <div></div>;
                }

            }
        },
        {
            name: '操作',
            cell: row => {
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                const projectEndTime = new Date(row.projectEndTime);
                projectEndTime.setHours(0, 0, 0, 0);
                if (row.isTrackedreport === 2 || projectEndTime < today) {
                    return null;
                }
                return (
                    < div >
                        {
                            row.isadminbuildTrack && (
                                <>
                                    {userType === 'M' && row.isNetTrack === false && row.problemReviewResults !== "4" && row.problemReviewResults !== "3" && (
                                        <Button color="primary" onClick={() => handleEdit(row)}>區網修改</Button>
                                    )}


                                    {userType === 'N' && row.isUnitTrack === false && row.problemPreliminaryResults !== "4" && row.problemPreliminaryResults !== "3" && (
                                        <Button color="primary" onClick={() => handleEdit(row)}>單位修改</Button>
                                    )}
                                </>
                            )
                        }
                        {
                            row.isNetbuildTrack && (
                                <>
                                    {userType === 'M' && row.isNetAndTrack === false && data.unit_data === "00000" && (row.problemPreliminaryResults !== "4" && row.problemPreliminaryResults !== "3") && (
                                        <Button color="primary" onClick={() => handleEdit(row)}>區網修改</Button>
                                    )}
                                    {userType === 'N' && row.isUnitTrack === false && (row.problemPreliminaryResults !== "4" && row.problemPreliminaryResults !== "3") && (
                                        <Button color="primary" onClick={() => handleEdit(row)}>單位修改</Button>
                                    )}
                                </>
                            )
                        }
                        {
                            row.isUnitbuildTrack && (
                                <>
                                    {userType === 'M' && row.isNetAndTrack === false && (row.problemPreliminaryResults !== "4" && row.problemPreliminaryResults !== "3") && (
                                        <Button color="primary" onClick={() => handleEdit(row)}>區網修改</Button>
                                    )}
                                    {userType === 'N' && row.isUnitTrack === false && (row.problemPreliminaryResults !== "4" && row.problemPreliminaryResults !== "3") && (
                                        <Button color="primary" onClick={() => handleEdit(row)}>單位修改</Button>
                                    )}
                                </>
                            )
                        }



                    </div >
                );
            },
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        }
    ];

    let netbuildTrackProcessed = false;
    if (trackingData) {
        Object.entries(trackingData).forEach(([id, groupData]) => {
            groupData.forEach(data => {
                if (data.isNetbuildTrack === true && !netbuildTrackProcessed) {
                    if (data.problemPreliminaryResults !== undefined || data.problemPreliminaryOpinion !== undefined) {
                        netbuildTrackProcessed = true;
                        const indexAfterSupportingInformation = columns.findIndex(column => column.name === '佐證資料') + 1;
                        const newColumns = [
                            {
                                name: '審核結果',
                                selector: row => row.problemPreliminaryResults,
                                sortable: false,
                                cell: row => {
                                    const ResultsLevelMapping = {
                                        '4': '同意',
                                        '3': '誤判',
                                        '2': '不同意',
                                        '1': '後續追蹤',
                                    };
                                    return <div className="wrap-text">{ResultsLevelMapping[row.problemPreliminaryResults]}</div>;
                                }
                            },
                            {
                                name: '審核意見',
                                selector: row => row.problemPreliminaryOpinion,
                                cell: row => <div className="wrap-text">{row.problemPreliminaryOpinion}</div>
                            },

                        ];
                        columns = [
                            ...columns.slice(0, indexAfterSupportingInformation),
                            ...newColumns,
                            ...columns.slice(indexAfterSupportingInformation)
                        ];
                    }
                } else if (data.isUnitbuildTrack === true && !netbuildTrackProcessed) {
                    if (data.problemPreliminaryResults !== undefined || data.problemPreliminaryOpinion !== undefined) {
                        netbuildTrackProcessed = true;
                        const indexAfterSupportingInformation = columns.findIndex(column => column.name === '佐證資料') + 1;
                        const newColumns = [
                            {
                                name: '審核結果',
                                selector: row => row.problemPreliminaryResults,
                                sortable: false,
                                cell: row => {
                                    const ResultsLevelMapping = {
                                        '4': '同意',
                                        '3': '誤判',
                                        '2': '不同意',
                                        '1': '後續追蹤',
                                    };
                                    return <div className="wrap-text">{ResultsLevelMapping[row.problemPreliminaryResults]}</div>;
                                }
                            },
                            {
                                name: '審核意見',
                                selector: row => row.problemPreliminaryOpinion,
                                cell: row => <div className="wrap-text">{row.problemPreliminaryOpinion}</div>
                            },

                        ];
                        columns = [
                            ...columns.slice(0, indexAfterSupportingInformation),
                            ...newColumns,
                            ...columns.slice(indexAfterSupportingInformation)
                        ];
                    }
                } else if (data.isadminbuildTrack === true && !netbuildTrackProcessed) {
                    if (userType === 'M' || (userType === 'N' && (data.problemReviewResults !== undefined || data.problemReviewOpinions !== undefined))) {
                        netbuildTrackProcessed = true;
                        const indexAfterSupportingInformation = columns.findIndex(column => column.name === '佐證資料') + 1;
                        const newColumns = [
                            {
                                name: '初審結果',
                                selector: row => row.problemPreliminaryResults,
                                sortable: false,
                                cell: row => {
                                    const ResultsLevelMapping = {
                                        '4': '同意',
                                        '3': '誤判',
                                        '2': '不同意',
                                        '1': '後續追蹤',
                                    };
                                    return <div className="wrap-text">{ResultsLevelMapping[row.problemPreliminaryResults]}</div>;
                                }
                            },
                            {
                                name: '初審意見',
                                selector: row => row.problemPreliminaryOpinion,
                                cell: row => <div className="wrap-text">{row.problemPreliminaryOpinion}</div>
                            },

                        ];
                        columns = [
                            ...columns.slice(0, indexAfterSupportingInformation),
                            ...newColumns,
                            ...columns.slice(indexAfterSupportingInformation)
                        ];
                        if (data.problemReviewResults !== undefined || data.problemReviewOpinions !== undefined) {
                            netbuildTrackProcessed = true;
                            const indexAfterSupportingInformation = columns.findIndex(column => column.name === '初審意見') + 1;
                            const newColumns = [
                                {
                                    name: '複審結果',
                                    selector: row => row.problemReviewResults,
                                    sortable: false,
                                    cell: row => {
                                        const ResultsLevelMapping = {
                                            '4': '同意',
                                            '3': '誤判',
                                            '2': '不同意',
                                            '1': '後續追蹤',
                                        };
                                        return <div className="wrap-text">{ResultsLevelMapping[row.problemReviewResults]}</div>;
                                    }
                                },
                                {
                                    name: '複審意見',
                                    selector: row => row.problemReviewOpinions,
                                    cell: row => <div className="wrap-text">{row.problemReviewOpinions}</div>
                                },

                            ];
                            columns = [
                                ...columns.slice(0, indexAfterSupportingInformation),
                                ...newColumns,
                                ...columns.slice(indexAfterSupportingInformation)
                            ];
                        }
                    }
                    else if (userType === 'N' && (data.problemPreliminaryResults !== undefined || data.problemPreliminaryOpinion !== undefined)) {
                        netbuildTrackProcessed = true;
                        const indexAfterSupportingInformation = columns.findIndex(column => column.name === '佐證資料') + 1;
                        const newColumns = [
                            {
                                name: '初審結果',
                                selector: row => row.problemPreliminaryResults,
                                sortable: false,
                                cell: row => {
                                    const ResultsLevelMapping = {
                                        '4': '同意',
                                        '3': '誤判',
                                        '2': '不同意',
                                        '1': '後續追蹤',
                                    };
                                    return <div className="wrap-text">{ResultsLevelMapping[row.problemPreliminaryResults]}</div>;
                                }
                            },
                            {
                                name: '初審意見',
                                selector: row => row.problemPreliminaryOpinion,
                                cell: row => <div className="wrap-text">{row.problemPreliminaryOpinion}</div>
                            },

                        ];
                        columns = [
                            ...columns.slice(0, indexAfterSupportingInformation),
                            ...newColumns,
                            ...columns.slice(indexAfterSupportingInformation)
                        ];
                    }

                }
            });
        });
    }


    const shouldShowSubmitButton = (groupData) => {
        return groupData.some(data => {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const projectEndTime = new Date(data.projectEndTime);
            projectEndTime.setHours(0, 0, 0, 0);
            if (data.isTrackedreport === 2 || projectEndTime < today) {
                return false;
            }
            if (data.isadminbuildTrack) {

                if (userType === 'M' && data.isNetTrack === false) {

                    return true;
                }
                if (userType === 'N' && data.isUnitTrack === false) {
                    return true;
                }
            }

            if (data.isNetbuildTrack) {
                if (userType === 'M' && data.isNetAndTrack === false && data.unit_data === "00000") {
                    return true;
                }
                if (userType === 'N' && data.isUnitTrack === false) {
                    return true;
                }
            }

            if (data.isUnitbuildTrack) {
                if (userType === 'M' && data.isNetAndTrack === false) {
                    return true;
                }
                if (userType === 'N' && data.isUnitTrack === false) {
                    return true;
                }
            }
            return false;
        });
    };

    return (
        <div >
            <SiteTitle />
            {Object.entries(trackingData).map(([scanId, groupData], index) => {
                return (
                    <div key={index} className="dataTable-wrapper">
                        <div className="dataTable-header">
                            <div className="header-item">
                                <div className="header-item">流水號: {groupData[0].projectreportname}</div>
                                主機名稱: {groupData[0].host_name} ({groupData[0].host_ip})
                                <Button onClick={() => toggleReportCollapse(scanId)} style={{ marginLeft: '10px' }}>
                                    {reportCollapseStatus[scanId] ? '展開' : '收起來'}
                                </Button>
                                {shouldShowSubmitButton(groupData) && (
                                    <Button
                                        onClick={() => {
                                            if (groupData[0].isadminbuildTrack) {
                                                userType === 'M' ? handleSubmitForM(groupData, scanId) : handleSubmitForN(groupData, scanId);
                                            } else {
                                                handleSubmitForN(groupData, scanId);
                                            }
                                        }}
                                        style={{ marginLeft: '10px' }}>
                                        單筆提交
                                    </Button>
                                )}
                            </div>
                        </div>
                        {!reportCollapseStatus[scanId] && (
                            <DataTable
                                noHeader
                                columns={columns}
                                // className="dataTable-container"
                                data={combinePdfData(groupData)}
                            />
                        )}
                    </div>
                );
            })}



            <Modal isOpen={modal} toggle={toggleModal} size="lg">
                <ModalHeader toggle={toggleModal}>修改數據</ModalHeader>
                <ModalBody>
                    {userType === 'N' ? (
                        <>
                            <Form>
                                <FormGroup>
                                    <Label for="problemType">問題類型</Label>
                                    <Input
                                        type="text"
                                        name="problemType"
                                        id="problemType"
                                        value={editData.problemType}
                                        onChange={e => setEditData({ ...editData, problemType: e.target.value })}
                                        readOnly
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Label for="problemRiskLevel">風險程度</Label>
                                    <Input
                                        type="select"
                                        name="problemRiskLevel"
                                        id="problemRiskLevel"
                                        value={editData.problemRiskLevel}
                                        onChange={e => setEditData({ ...editData, problemRiskLevel: e.target.value })}
                                        disabled
                                    >
                                        <option value="4">高</option>
                                        <option value="3">中</option>
                                        <option value="2">低</option>
                                        <option value="1">訊息</option>
                                        <option value="0">-</option>
                                    </Input>
                                </FormGroup>
                                <FormGroup>
                                    <Label for="problemNumber">問題數量</Label>
                                    <Input
                                        type="text"
                                        name="problemNumber"
                                        id="problemNumber"
                                        value={editData.problemNumber}
                                        onChange={e => setEditData({ ...editData, problemNumber: e.target.value })}
                                        readOnly
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Label for="problemimProvementResponse">改善回應</Label>
                                    <Input
                                        type="textarea"
                                        name="problemimProvementResponse"
                                        id="problemimProvementResponse"
                                        value={editData.problemimProvementResponse}
                                        onChange={e => setEditData({ ...editData, problemimProvementResponse: e.target.value })}
                                        rows="10"
                                        style={{ resize: 'none', overflow: 'auto' }}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Label for="problemProcessingMethod">處理方式</Label>
                                    <Input
                                        type="select"
                                        name="problemProcessingMethod"
                                        id="problemProcessingMethod"
                                        value={editData.problemProcessingMethod}
                                        onChange={e => setEditData({ ...editData, problemProcessingMethod: e.target.value })}
                                    >
                                        <option value="4">已修補</option>
                                        <option value="3">未修補</option>
                                        <option value="2">誤判</option>
                                        <option value="1">其他</option>
                                    </Input>
                                </FormGroup>
                                <FormGroup>
                                    <Label for="problemSupportingInformation">佐證資料</Label>
                                    <Input
                                        type="file"
                                        name="problemSupportingInformation"
                                        id="problemSupportingInformation"
                                        multiple
                                        onChange={handleFileChange}
                                        accept=".pdf"
                                    />
                                    <div className="uploaded-files">
                                        {uploadedFiles.map((file, index) => (
                                            <div key={index}>
                                                <span>{index + 1}. {file.name}</span>
                                                <Button onClick={() => handleRemoveFile(file.id, index)}>
                                                    <FontAwesomeIcon icon={faTimes} />
                                                </Button>
                                            </div>
                                        ))}
                                    </div>
                                </FormGroup>
                            </Form>
                        </>
                    ) : userType === 'M' ? (
                        <>
                            {editData.isNetbuildTrack ? (
                                <>
                                    <Form>
                                        <FormGroup>
                                            <Label for="problemType">問題類型</Label>
                                            <Input
                                                type="text"
                                                name="problemType"
                                                id="problemType"
                                                value={editData.problemType}
                                                onChange={e => setEditData({ ...editData, problemType: e.target.value })}
                                                readOnly
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label for="problemRiskLevel">風險程度</Label>
                                            <Input
                                                type="select"
                                                name="problemRiskLevel"
                                                id="problemRiskLevel"
                                                value={editData.problemRiskLevel}
                                                onChange={e => setEditData({ ...editData, problemRiskLevel: e.target.value })}
                                                disabled
                                            >
                                                <option value="4">高</option>
                                                <option value="3">中</option>
                                                <option value="2">低</option>
                                                <option value="1">訊息</option>
                                                <option value="0">-</option>
                                            </Input>
                                        </FormGroup>
                                        <FormGroup>
                                            <Label for="problemNumber">問題數量</Label>
                                            <Input
                                                type="text"
                                                name="problemNumber"
                                                id="problemNumber"
                                                value={editData.problemNumber}
                                                onChange={e => setEditData({ ...editData, problemNumber: e.target.value })}
                                                readOnly
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label for="problemimProvementResponse">改善回應</Label>
                                            <Input
                                                type="textarea"
                                                name="problemimProvementResponse"
                                                id="problemimProvementResponse"
                                                value={editData.problemimProvementResponse}
                                                onChange={e => setEditData({ ...editData, problemimProvementResponse: e.target.value })}
                                                rows="10"
                                                style={{ resize: 'none', overflow: 'auto' }}
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label for="problemProcessingMethod">處理方式</Label>
                                            <Input
                                                type="select"
                                                name="problemProcessingMethod"
                                                id="problemProcessingMethod"
                                                value={editData.problemProcessingMethod}
                                                onChange={e => setEditData({ ...editData, problemProcessingMethod: e.target.value })}
                                            >
                                                <option value="4">已修補</option>
                                                <option value="3">未修補</option>
                                                <option value="2">誤判</option>
                                                <option value="1">其他</option>
                                            </Input>
                                        </FormGroup>
                                        <FormGroup>
                                            <Label for="problemSupportingInformation">佐證資料</Label>
                                            <Input
                                                type="file"
                                                name="problemSupportingInformation"
                                                id="problemSupportingInformation"
                                                multiple
                                                onChange={handleFileChange}
                                                accept=".pdf"
                                            />
                                            <div className="uploaded-files">
                                                {uploadedFiles.map((file, index) => (
                                                    <div key={index}>
                                                        <span>{index + 1}. {file.name}</span>
                                                        <Button onClick={() => handleRemoveFile(file.id, index)}>
                                                            <FontAwesomeIcon icon={faTimes} />
                                                        </Button>
                                                    </div>
                                                ))}
                                            </div>
                                        </FormGroup>
                                    </Form>
                                </>
                            ) : (
                                <>
                                    <FormGroup>
                                        <Label for="problemPreliminaryResults">初審結果</Label>
                                        <Input
                                            type="select"
                                            name="problemPreliminaryResults"
                                            id="problemPreliminaryResults"
                                            value={editData.problemPreliminaryResults}
                                            onChange={e => setEditData({ ...editData, problemPreliminaryResults: e.target.value })}
                                            disabled={userType !== 'M'}
                                        >
                                            <option value="">請選擇</option>
                                            <option value="4">同意</option>
                                            <option value="3">誤判</option>
                                            <option value="1">後續追蹤</option>
                                            <option value="2">不同意</option>
                                        </Input>
                                    </FormGroup>
                                    <FormGroup>
                                        <Label for="problemPreliminaryOpinion">初審意見</Label>
                                        <Input
                                            type="textarea"
                                            name="problemPreliminaryOpinion"
                                            id="problemPreliminaryOpinion"
                                            value={editData.problemPreliminaryOpinion}
                                            onChange={e => setEditData({ ...editData, problemPreliminaryOpinion: e.target.value })}
                                            rows="8"
                                            style={{ resize: 'none', overflow: 'auto' }}
                                            readOnly={userType !== 'M'}
                                        />
                                    </FormGroup>
                                </>
                            )}
                        </>
                    ) : null}
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={() => (userType === 'M' && editData.isadminbuildTrack) ? handleUpdateForM(selectedId) : handleUpdateForN(selectedId)}>
                        保存
                    </Button>  <Button color="secondary" onClick={toggleModal}>取消</Button>
                </ModalFooter>
            </Modal>
        </div>
    );

}

export default FetchTenTrackingDetail;